export const createBannerState = () => ({
    variant_name: 'info',
    message: '',
    dismissible: true,
    show_feedback_link: false,
    active: true,
    sort_order: 0,
    color: '#007bff',
});
